import { render, staticRenderFns } from "./ConnMould.vue?vue&type=template&id=9cbc986c&"
import script from "./ConnMould.vue?vue&type=script&lang=js&"
export * from "./ConnMould.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports